<!-- 自定义标签模板弹框 -->
<template>
  <el-dialog 
    append-to-body
    width="1000px" 
    title="自定义标签模板" 
    top="100px" 
    custom-class="custom-tag-dialog"
    :close-on-click-modal="false" 
    :lock-scroll="false"
    :visible.sync="isShow" 
    @close="close"
  >
    <div class="custom-tag-dialog__content">
      <el-table
        border
        style="width: 100%"
        v-loading="loading"
        highlight-current-row
        max-height="500"
        :data="list"
        :row-class-name="({row}) => row.id == currentId ? 'current-row' : ''"
        @row-click="handleCurrentChange"
      >
        <!-- 选择 -->
        <el-table-column align="center" class-name="radio-column" label="选择" width="50">
          <template slot-scope="{ row }">
            <span :class="`custom-tag-dialog__content__radio ${row.id == currentId ? 'selected' : ''}`"></span>
          </template>
        </el-table-column>
        <!-- 模板名称 -->
        <el-table-column align="center" property="name" label="模板名称" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.is_default == 1" class="is-default">[默认] </span>
            {{ row.name }}
          </template>
        </el-table-column>
        <!-- 修改时间 -->
        <el-table-column align="center" property="update_time_desc" label="修改时间"></el-table-column>
        <!-- 最新使用时间 -->
        <el-table-column align="center" property="last_usetime_desc" label="最新使用时间"></el-table-column>
        <!-- 最新使用订单号 -->
        <el-table-column 
          align="center"
          prop="last_order_id" 
          label="最新使用订单号"
          :formatter="row => +row.last_order_id ? row.last_order_id : '无'"
        ></el-table-column>
        <!-- 预览 -->
        <el-table-column align="center" width="100px" label="预览">
          <template slot-scope="{ row }">
            <div @click.stop>
              <el-image
                style="width: 100%"
                fit="fill"
                :src="row.preview_img"
                :preview-src-list="[row.preview_img]"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column header-align="center" width="220px" label="操作">
          <template slot-scope="{ row }">
            <div class="custom-tag-dialog__content__btns" @click.stop>
              <template v-if="row.type != 3">
                <el-button 
                  type="text" 
                  class="copy" 
                  :disabled="row.paperSize !== '60*40'"
                  @click="handlGoCustomTags('copy', row.id)"
                >复制</el-button>
                <el-button 
                  type="text" 
                  class="edit" 
                  @click="handlGoCustomTags('edit', row.id)"
                >修改</el-button>
                <el-button 
                  type="text" 
                  class="delete" 
                  @click="handleDel(row)"
                >删除</el-button>
              </template>
              <el-button 
                v-if="row.is_default != 1" 
                type="text" 
                class="default" 
                @click="handleSetDefault(row.id)"
              >设置为默认</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="custom-tag-dialog__footer">
      <el-popover
        placement="top-start"
        width="100"
        trigger="hover"
        :disabled="limitMax > listLength"
        :content="`最多添加${limitMax}个模板`"
      >
        <el-button 
          slot="reference" 
          size="medium" 
          :disabled="limitMax <= listLength"
          @click="handlGoCustomTags('add')"
        >新增模板</el-button>
      </el-popover>
      <el-button size="medium" type="primary" @click="handleConfirm">确认选择</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CONFIG from '@@/config'
import { getCustomTagsList, deleteCustomTags, setDefaultCustomTags } from '@@/api/pcb'

export default {
  data() {
    return {
      isShow: false,
      loading: false,
      currentId: '',
      currentItem: {},
      list: [], // 标签列表
      limitMax: 10, // 最大限制5个模板
    }
  },
  created() {
    this.getList()
  },
  computed: {
    // 除去旧标签的列表长度
    listLength() {
      return this.list.filter(item => item.type != 3)
    }
  },
  methods: {
    open(currentId) {
      this.isShow = true
      this.currentId = currentId || ''
      this.getList()
      // 监听浏览器标签页切换
      document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    },
    close() {
      this.isShow = false
      this.loading = false
      document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
    },
    // 浏览器标签页切换
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.getList()
      }
    },
    // 获取标签列表
    getList() {
      this.loading = true
      getCustomTagsList()
        .then(res => {
          const { retCode, result = {} } = res
          if (retCode === 0) {
            this.list = result.list || []
            this.handleSelectDefault()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择默认的标签
    handleSelectDefault() {
      const { currentId, list } = this
      if (list && list.length === 0) return
      // 已选的 > 默认的 > 第一个
      let item
      if (currentId) {
        item = list.find(i => i.id == currentId)
      } else {
        item = list.find(i => i.is_default == 1) || list[0]
      }
      this.handleCurrentChange(item)
    },
    // 选择标签
    handleCurrentChange(item) {
      if (!item) return
      this.currentId = item.id
      this.currentItem = item
    },
    // 新增、复制、编辑 标签
    handlGoCustomTags(type, id) {
      const params = type === 'add' ? 'type=add' : `type=${type}&id=${id}`
      window.open(`${CONFIG.HQPCB_HOST}/customtag/pcb?${params}`)
    },
    // 删除标签
    handleDel({ id, name } = {}) {
      this.$msgbox({
        title: '提示',
        message: `是否确认删除 ${name}？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            deleteCustomTags({ id })
              .then(res => {
                const { retCode, retMsg } = res
                if (retCode === 0) {
                  this.$message.success('删除成功')
                  if (this.currentId === id) {
                    this.currentId = ''
                    this.currentItem = {}
                  }
                  this.$emit('delete', id)
                } else {
                  this.$message.error(retMsg)
                }
                this.getList()
              })
              .finally(() => {
                done()
                instance.confirmButtonLoading = false
              })
          } else {
            done()
          }
        }
      })
    },
    // 设为默认
    handleSetDefault(id) {
      setDefaultCustomTags({id})
        .then(res => {
          const { retCode, retMsg } = res
          if (retCode === 0) {
            this.$message.success('设置默认成功')
          } else {
            this.$message.error(retMsg)
          }
          this.getList()
        })
    },
    // 确认选择
    handleConfirm() {
      const { currentId, currentItem } = this
      if (!currentId || !currentItem.name) {
        return this.$message.error('请选择一个标签模板！')
      }
      this.$emit('confirm', currentId, currentItem.name)
      this.close()
    }
  }
}
</script>

<style lang="scss">
.custom-tag-dialog__content {
  .el-table {
    border: 1px solid #ececec;
    border-radius: 3px;
    border-bottom: 0;
    thead th {
      padding: 6px 0;
      font-weight: 400;
      background: #F5F7FA;
      color: $--color-text-secondary;
    }
    .el-table__row {
      cursor: pointer;
    }
    .radio-column .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .is-default {
    color: $--color-warning;
  }
  .el-image {
    display: block;
  }
  .custom-tag-dialog__content__radio {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid #C1C3C8;
    border-radius: 50%;
    &.selected {
      border-color: $--color-primary;
      &::after {
        content: '';
        position: absolute;
        top: 4px;
        left: 4px;
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $--color-primary;
      }
    }
  }
  .custom-tag-dialog__content__btns {
    .copy,
    .edit {
      color: $--form-color-base;
    }
    .delete {
      color: $--color-danger;
    }
    .default {
      color: $--color-warning;
    }
    .el-button.is-disabled {
      color: $--color-text-disabled;
    }
  }
}
.custom-tag-dialog__footer {
  .el-button {
    margin-left: 10px;
    &.el-button--default {
      &:hover {
        color: #059A58;
        border-color: #b4e1cd;
        background-color: #e6f5ee;
      }
    }
    &.el-button--primary {
      border-color: #C00;
      background-color: #C00;
      &:hover {
        border-color: #B80000;
        background-color: #B80000;
      }
    }
  }
}
</style>